import { UserPreferences } from '../types';
import { apiClient } from './api';

class PreferencesService {
  private baseUrl = '/preferences';

  async updatePreferences(
    preferences: Partial<UserPreferences>
  ): Promise<UserPreferences> {
    const response = await apiClient.put<UserPreferences>(this.baseUrl, {
      preferences,
    });
    return response.data;
  }

  async updatePreference(key: string, value: any): Promise<UserPreferences> {
    // Build nested preference object from dot notation key
    const keyParts = key.split('.');
    const preferences: any = {};
    let current = preferences;

    for (let i = 0; i < keyParts.length - 1; i++) {
      current[keyParts[i]] = {};
      current = current[keyParts[i]];
    }
    current[keyParts[keyParts.length - 1]] = value;

    return this.updatePreferences(preferences);
  }
}

export const preferencesService = new PreferencesService();
